import React, {useEffect, useState} from "react";
import {usePageContext} from "vike-react/usePageContext";
import AppConstants from "#/src/utils/app-constants";
import {composeHeaders, composeQuery} from "#/src/utils/api-request-utils";
import {AppPageContext, PaginatedRequest} from "#/src/definitions/AppDefinitions";
import {Sort} from "#/src/utils/sort-utils";
import {ApiVideo} from "#/src/definitions/ApiDefinitions";
import {VideoCard} from "#/src/components/VideoCard";
import {LoadableButton} from "#/src/components/LoadableButton";
import {LoaderSvg} from "#/src/components/LoaderSvg";
import styled from "@emotion/styled";

const LoadMoreButton = styled(LoadableButton)`
  min-width: 12em;
`;

export function AwaitingContent() {
  const pageContext = usePageContext() as AppPageContext;
  const [videoData, setVideoData] = useState({loading: false, error: false, data: [], page: 1, maxPages: 2});
  useEffect(() => {
    setVideoData({...videoData, page: 1, maxPages: 1, loading: true});
    doFetchVideos(1).then(res => {
      setVideoData({...videoData, data: Sort.byDate(res.data), maxPages: res.maxPages, error: false, loading: false})
    }).catch(() => setVideoData({...videoData, error: true, loading: false}));
  }, []);

  async function onPageFetch() {
    const nextPage = videoData.page + 1;
    setVideoData(oldVideo => ({...oldVideo, loading: true}));
    return doFetchVideos(nextPage).then(res => {
      setVideoData(oldVideo => ({...oldVideo, data: [...videoData.data, ...Sort.byDate(res.data)], page: res.page, maxPages: res.maxPages, error: false, loading: false}));
    }).catch(() => setVideoData(oldVideo => ({...oldVideo, error: true, loading: false})));
  }

  async function doFetchVideos(page) {
    const query = composeQuery({page});
    const result = await fetch(`${AppConstants.API_ROUTE}/videos/awaiting?${query}`, {method: "GET", headers: composeHeaders(pageContext)});
    if (result.ok) {
      const pageData = await result.json() as PaginatedRequest<ApiVideo>;
      return Promise.resolve(pageData);
    }
    return Promise.reject();
  }

  function render() {
    return <section className="front-header mt-9">
      <div className="container-xxl">
        <div className={"row"}>{renderVideos()}</div>
        {renderFetchButton()}
      </div>
    </section>
  }

  function renderVideos() {
    if (videoData.error) {
      return <div className={"text-center text-danger"}>Nie udało się załadować...</div>
    }
    if(videoData.loading) {
      return <div className={"text-center text-loading"}><LoaderSvg/> Ładuję zawartość...</div>
    }
    return videoData.data.map((video: ApiVideo) => <div key={video.id} className="col-xl-3 col-sm-6 col-md-4"><VideoCard video={video}/></div>);
  }

  function renderFetchButton() {
    if (videoData.maxPages <= videoData.page) {
      return <></>
    }
    return <div className={"row justify-content-center"}>
      <div className={"text-center"}>
        <LoadMoreButton className={"btn btn-secondary"} onClick={onPageFetch}>Załaduj więcej</LoadMoreButton>
      </div>
    </div>
  }


  return render();
}